<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900">
    <template v-slot:title>{{ editorTitle }}</template>
    <v-row>
      <v-col>
        <travel-list-select
          item-value="id"
          v-model="supplierId"
          :outlined="outlinedInputs"
          :disabled="lockSupplier"
          dense
          hide-details
          clearable
        />
      </v-col>
      <v-col>
        <v-text-field
          v-model="flightNo"
          label="Flight No"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <date-picker
          customLabel="Valid From"
          v-model="validFrom"
          :outlined="outlinedInputs"
          hide-details
        ></date-picker>
      </v-col>
      <v-col>
        <date-picker
          customLabel="Valid to"
          v-model="validTo"
          :outlined="outlinedInputs"
          hide-details
        ></date-picker>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          v-model="departurePoint"
          label="Departure Point"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-menu
          ref="departureTime"
          v-model="departureTimeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="departureTime"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          v-if="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="departureTime"
              label="Departure Time"
              prepend-inner-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
              :outlined="outlinedInputs"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="departureTimeMenu"
            v-model="departureTime"
            full-width
            @click:minute="$refs.departureTime.save(departureTime)"
          ></v-time-picker>
        </v-menu>
        <v-text-field
          v-model="departureTime"
          label="Departure Time"
          type="time"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
      <v-col>
        <v-text-field
          v-model="arrivalPoint"
          label="Arrival Point"
          :outlined="outlinedInputs"
        />
      </v-col>
      <v-col>
        <v-menu
          ref="arrivalTime"
          v-model="arrivalTimeMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          :return-value.sync="arrivalTime"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="290px"
          v-if="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="arrivalTime"
              label="Arrival Time"
              prepend-inner-icon="access_time"
              readonly
              v-bind="attrs"
              v-on="on"
              :outlined="outlinedInputs"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="arrivalTimeMenu"
            v-model="arrivalTime"
            full-width
            @click:minute="$refs.arrivalTime.save(arrivalTime)"
          ></v-time-picker>
        </v-menu>
        <v-text-field
          v-model="arrivalTime"
          label="Arrival Time"
          type="time"
          :outlined="outlinedInputs"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="3">
        <v-select
          label="Flight Type"
          v-model="flightType"
          :items="flightTypes"
          :outlined="outlinedInputs"
        ></v-select>
      </v-col>
      <v-col>
        <v-select
          :items="daysOfWeek"
          item-text="name"
          item-value="value"
          label="Days of Week"
          v-model="weekDays"
          multiple
          :outlined="outlinedInputs"
          hide-details
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-switch v-model="isException" label="Is Exception"></v-switch>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-btn color="primary" @click="onSave" :disabled="!isValid">Save</v-btn>
    </template>
    <v-row v-if="debug">
      <v-col>
        <pre>
        {{ validFrom }}--{{ validTo }}--{{ departureTime }}--{{ arrivalTime }}
      </pre
        >
      </v-col>
    </v-row>
  </basic-dialog>
</template>

<script>
import BasicDialog from "../../shared/BasicDialog.vue";
import DatePicker from "../../shared/DatePicker.vue";
import TravelListSelect from "../../shared/TravelListSelect.vue";
var moment = require("moment");

export default {
  name: "flight-edit-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    forSupplier: {
      type: Boolean,
      default: () => false,
    },
  },

  components: { BasicDialog, TravelListSelect, DatePicker },

  data() {
    return {
      debug: false,
      arrivalTimeMenu: false,
      departureTimeMenu: false,
      flightTypes: ["Flight", "Inbound Flight", "Outbound Flight"],
      daysOfWeek: [
        { name: "Monday", value: "1" },
        { name: "Tuesday", value: "2" },
        { name: "Wednesday", value: "3" },
        { name: "Thursday", value: "4" },
        { name: "Friday", value: "5" },
        { name: "Saturday", value: "6" },
        { name: "Sunday", value: "7" },
      ],
      id: this.value ? this.value.id : null,
      flightNo: this.value ? this.value.flightNo : "",
      flightType: this.value ? this.value.flightType : "Flight",
      validFrom: this.value ? this.value.validFrom : "",
      validTo: this.value ? this.value.validTo : "",
      departureTime: this.value ? this.value.departureTime : "",
      departurePoint: this.value ? this.value.departurePoint : "",
      arrivalTime: this.value ? this.value.arrivalTime : "",
      arrivalPoint: this.value ? this.value.arrivalPoint : "",
      weekDays: this.value
        ? this.value.weekDays.toString().split(",")
        : ["1", "2", "3", "4", "5", "6", "7"],
      isException: this.value ? this.value.isException : false,
      supplierId: this.value ? this.value.supplierId : null,
    };
  },

  computed: {
    lockSupplier() {
      return !!(this.forSupplier && this.value && this.value.supplierId);
    },
    editorTitle() {
      return `${
        this.value && this.value.id ? "Edit " + this.value.flightNo : "Add"
      } Flight`;
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    isValid() {
      return this.flightNo != "" && this.supplierId != "";
    },
  },

  watch: {
    value(newVal) {
      if (newVal) {
        this.id = newVal.id;
        this.flightNo = newVal.flightNo;
        this.flightType = newVal.flightType;
        this.validFrom = newVal.validFrom;
        this.validTo = newVal.validTo;
        this.departureTime = newVal.departureTime;
        this.departurePoint = newVal.departurePoint;
        this.arrivalTime = newVal.arrivalTime;
        this.arrivalPoint = newVal.arrivalPoint;
        this.weekDays = newVal.weekDays
          ? newVal.weekDays.toString().split(",")
          : [];
        this.isException = newVal.isException;
        this.supplierId = newVal.supplierId;
      } else {
        this.id = null;
        (this.flightNo = ""), (this.flightType = "Flight");
        this.validFrom = "";
        this.validTo = "";
        this.departureTime = "";
        this.departurePoint = "";
        this.arrivalTime = "";
        this.arrivalPoint = "";
        this.weekDays = [];
        this.isException = false;
        this.supplierId = null;
      }
    },
  },

  methods: {
    onSave() {
      const flight = {
        flightNo: this.flightNo.toString(),
        flightType: this.flightType.toString(),
        validFrom: moment(this.validFrom).toISOString(true),
        validTo: moment(this.validTo).toISOString(true),
        departureTime: this.departureTime ? this.departureTime.toString() : "",
        departurePoint: this.departurePoint.toString(),
        arrivalTime: this.arrivalTime ? this.arrivalTime.toString() : "",
        arrivalPoint: this.arrivalPoint.toString(),
        weekDays: this.weekDays ? this.weekDays.join(",") : "",
        isException: this.isException,
        supplierId: this.supplierId,
      };
      const input = this.id
        ? { id: this.id, input: flight }
        : { input: flight };
      this.$emit("input", input);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/plugins/flights/FlightEditDialog.vue